import { useState, useEffect } from "react"
import axios from "axios"

import prin from "../assets/staff/princ.jpg"
import ksarojini from "../assets/staff/Ksarojini.jpg"
import dp from "../assets/staff/dp.jpg"
import gupta from "../assets/staff/gupta.jpg"
import krk from "../assets/staff/krk.jpg"
import gvr from "../assets/staff/gvr.jpg"
import css from "../assets/staff/css.jpg"
import ln from "../assets/staff/ln.jpg"
import mvp from "../assets/staff/mvp.jpg"
import trs from "../assets/staff/trs.jpg"
import pd from "../assets/staff/pd.jpg"
import ex from "../assets/cover2.jpeg"
import swaraj from "../assets/staff/swaraj.jpg"
export default function Faculty() {
  const defaultStaff = [
    {
      name: "M Kamala Kumari",
      designation: "Principal",
      
      image: prin,
      local:true,
    },
    {
      name: "Smt K Sarojini",
      designation: "Senior Lecturer",
      
      image: ksarojini,
      local:true,
    },
    {
      name: "Sri P Durga Prasad",
      designation: "Senior Lecturer",
      
      image: dp,
      local:true,
    },
    {
      name: "Sri A S S R Ch Gupta",
      designation: "Lecturer",
     
      image: gupta,
      local:true,
    },{
      name: "Sri K Raj Kumar",
      designation: "Lecturer",
      
      image: krk,
      local:true,
    },{
      name: "Sri Ch Govinda Raju",
      designation: "Lecturer",
     
      image: gvr,
      local:true,
    },{
      name: "Sri C Samuel Sanjeev",
      designation: "Lecturer",
     
      image: css,
      local:true,
    },{
      name: "Sri Ch Lakshmi Narayana",
      designation: "Lecturer",
        image: ln,
      local:true,
    },{
      name: "Sri T Raja Shekar",
      designation: "Lecturer",
    
      image: trs,
      local:true,
    },{
      name: "Sri B Johnson",
      designation: "Lecturer",
      
      image: pd,
      local:true,
    },
    {
      name: "Smt M Vijaya Prasanna",
      designation: "Lecturer",
    
      image: mvp,
      local:true,
    },
    {
      name: "Sri V Venkateswara Rao",
      designation: "Lecturer",
      
      image: ex,
      local:true,
    },
    {
      name: "Sri Y Swarajya Srinivas",
      designation: "Lecturer",
     
      image: swaraj,
      local:true,
    },
  ];

const [staff, setStaff] = useState(defaultStaff);
useEffect(() => {
  axios
    .get("http://dietdubacherla.in/diet_backend/get_faculty.php")
    .then((res) => {
      console.log("Faculty Response:", res.data);

      if (Array.isArray(res.data) && res.data.length > 0) {
        setStaff(res.data);
      } else {
        setStaff(defaultStaff);
      }
    })
    .catch((err) => {
      console.log(err);
      setStaff(defaultStaff);
    });
}, []);
  return (
    <div style={{ padding: "40px" }}>
      <div
  style={{
    background: "linear-gradient(135deg,#660909,#9d1b1b)",
    color: "white",
    padding: "5px 20px",
    textAlign: "center",
    marginBottom: "20px",
   
  }}
>
  <h1>Faculty & Staff</h1>
  <p>
    Meet the dedicated teaching and non-teaching staff of
    DIET Dubacherla
  </p>
</div>


      <div style={gridStyle}>
        { Array.isArray(staff) &&
        staff.map((member, index) => (
          <div key={index} style={cardStyle}>
         <img
            src={
              member.local
                ? member.image
                : `http://dietdubacherla.in/diet_backend/uploads/faculty/${member.image}`
            }
            alt={member.name}
            style={imageStyle}
          />


            <h3>{member.name}</h3>

            <p>
              <strong>Designation: {member.designation}</strong>
            </p>

            <p>Qualification: {member.qualification}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

const cardStyle = {
  background: "#fff",
  borderRadius: "20px",
  overflow: "hidden",
  textAlign: "center",
  boxShadow: "0 8px 20px rgba(0,0,0,0.12)",
  transition: "all 0.3s ease",
  cursor: "pointer",
};

const imageStyle = {
  width: "120px",
  height: "120px",
  borderRadius: "50%",
  objectFit: "cover",
  marginTop: "20px",
  border: "5px solid #660909",
};

const gridStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit,minmax(280px,1fr))",
  gap: "30px",
};